import router from './';
import {checkAuthorization} from "@/utils/authorization-store"

router.beforeEach((to, from, next) => {
    if (!checkAuthorization() && to.name !== 'login' && to.name !== 'login-mobile') {
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            next({path: '/mobile/login'});
        } else {
            next({path: '/login'});
        }
        return;
    }
    next();

    // 变更网页标题
    let title = to.meta.title;
    if (title) {
        title = "安保能 - " + title;
    } else {
        title = "安保能 - 开发中";
    }
    document.title = title;

});
